import React, { useEffect, useRef } from 'react'
import { INLINES } from '@contentful/rich-text-types';
import { documentToReactComponents } from '@contentful/rich-text-react-renderer';
import './Info.scss'
import Header from '../components/Header.js';
import { motion, AnimatePresence } from 'framer-motion';
import { Helmet } from 'react-helmet';
import Lenis from 'lenis';


const Info = ({ info, buttons }) => {

    const lenisRef = useRef(null);

    // Scroll to top when component mounts
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    // Smooth/slow scroll
    useEffect(() => {
        const lenis = new Lenis({
            smoothWheel: true,
            smoothTouch: true,   // enable smoothing on touch
            wheelMultiplier: 0.8,
            touchMultiplier: 0.9,
        });

        lenisRef.current = lenis;

        let rafId;
        const raf = (time) => {
            lenis.raf(time);
            rafId = requestAnimationFrame(raf);
        };
        rafId = requestAnimationFrame(raf);

        return () => {
            cancelAnimationFrame(rafId);
            lenis.destroy();
            lenisRef.current = null;
        };
    }, []);

    const renderOptions = {
        renderText: text =>
            text.split('\n').reduce((children, textSegment, index) => {
                return [...children, index > 0 && <br key={index} />, textSegment];
            }, []),
        renderNode: {
            [INLINES.HYPERLINK]: (node, children) => {
                const { uri } = node.data;
                return (
                    <a href={uri} target="_blank" rel="noopener noreferrer">
                        {children}
                    </a>
                );
            },
        },
    };


    return (

        <AnimatePresence mode="wait">
            <motion.div
                // className="portraits-container-square"
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                exit={{ opacity: 0 }}
                transition={{ duration: 1 }}
            >
                <Helmet>
                    <title>Info • Alex de Brabant</title>
                    <meta name="description" content="Alex de Brabant is a Canadian artist and photographer based in Berlin, working at the intersection of art, culture, design, and ecology." />
                    <link rel="canonical" href="https://alexdebrabant.com/info" />
                    <meta property="og:title" content="Info • Alex de Brabant" />
                    <meta property="og:description" content="Alex de Brabant is a Canadian artist and photographer based in Berlin, working at the intersection of art, culture, design, and ecology." />
                    <meta property="og:type" content="website" />
                    <meta name="twitter:card" content="summary_large_image" />
                    <meta name="twitter:title" content="Info • Alex de Brabant" />
                    <meta name="twitter:description" content="Alex de Brabant is a Canadian artist and photographer based in Berlin, working at the intersection of art, culture, design, and ecology." />
                </Helmet>

                <Header pageTitle="Info" buttons={buttons} />

                <div className="info-container">
                    {info && info.infoText ? (
                        <div className="info-text">
                            {documentToReactComponents(info.infoText, renderOptions)}
                        </div>
                    ) : (
                        <div>Loading info...</div>
                    )}
                </div>
            </motion.div>
        </AnimatePresence>
    )
}

export default Info